module.exports = __webpack_public_path__ + "static/media/Employment-Contract.5f34d8ec.pdf";